/**
 * represent the event type of LLM Response
 */
export enum ChatResponseEventType {
  Reasoning = "reasoning",
  OutputText = "output_text",
  Progress = "progress", // For Deep Research

  LLMRequestID = "llm_request_id",
}
